import * as React from 'react';
import * as _ from 'underscore';

import { ConnectedExplorer } from '../app/spaces/Explorer/ConnectedExplorer';
import { ConnectedQueryParamUpdateProvider } from '../app/spaces/RouterHelpers/QueryParamUpdateProvider';
import { ConnectedExplorerSubspaceInitializer } from '../app/spaces/SpaceConfig/ExplorerSubspaceInitializer';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '../app/state/SpaceInfo';
import { SpaceContainerStyles } from '../style/SpaceContainerStyles';
import { AngularContext } from '../ts/factories/AngularContextFactory';
import { ExplorableItemDefinition } from '../ts/models/ContentDefinitions';
import { IContentType } from '../ts/models/ContentTypes';
import { Telemetry } from '../ts/services/TelemetryService';
import { CatalogContentType } from './CatalogContentType';


export interface CatalogBrowserSubspaceExplorerProps {
  readonly subspaceName: CatalogContentType;
  readonly routeLocationSearch: string;
  readonly angularContext: AngularContext;
  readonly contentDefinition: ExplorableItemDefinition;
  readonly contentType: IContentType;
  readonly telemetry: Telemetry;
}

export function CatalogBrowserSubspaceExplorer(props: CatalogBrowserSubspaceExplorerProps): JSX.Element {

  const queryUpdaterProps = {
    routeLocationPath: '',
    routeLocationSearch: props.routeLocationSearch,
    updateContentTypes: true,
    updateFilters: true,
    updateBreadcrumbs: false, // Breadcrumbs are updated by the DC3 code
    updateSort: true,
  };

  // The catalog space is scoped to the site and has its own subspaces, but it's not the same as the explore space,
  // so we should likely give it its own space type.
  // See https://gitlab.tableausoftware.com/browser-clients/vizportalclient/merge_requests/2733/diffs#note_651328
  const spaceInfo: SpaceInfo = {
    item: SpaceItemForNonEntitySpace,
    spaceType: 'site',
    subspaceName: props.subspaceName,
  };

  return (
    <div className={SpaceContainerStyles.SubplaceArea}>
      <ConnectedQueryParamUpdateProvider {...queryUpdaterProps}>
        <ConnectedExplorerSubspaceInitializer routeLocationSearch={props.routeLocationSearch} spaceInfo={spaceInfo}>
          <ConnectedExplorer
            angularContext={props.angularContext}
            supportedDisplayModes={props.contentDefinition.supportedDisplayModes}
            telemetry={props.telemetry}
            toolbarProps={{
              supportFilterPanel: props.contentType.canShowFilterPanel,
              toolbarVisibility: 'enabled'
            }}
          />
        </ConnectedExplorerSubspaceInitializer>
      </ConnectedQueryParamUpdateProvider>
    </div>
  );
}
